angular.module('bmsApp.trugreen.schedule')
	.controller('TGMoveMultipleVisitsModalCtrl', function ($scope,
												  $modalInstance,
												  $q,
												  $ngBootbox,
												  EmployeeSvc,
												  TGVisitSvc,
												  ConfigService,
												  TGScheduleSvc,
												  employee) {


		function init() {
			$scope.config = ConfigService.config;
			$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
				options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
					parentEl: '.modal-content'
				})
			});

			self.employee = employee;
		}

		function cancelVisit() {
			self.visit.inactive = true;
			self.visit.selected = false;
			angular.forEach(self.visit.treatments, function (treatment) {
				treatment.selected = false;
				if (!treatment.delete) {
					treatment.inactive = true;
				}

			});
		}

		function dateChanged() {
			if (self.moveToDate != null) {
				var employeeParams = {
					filter: {
						availableOnDate: self.moveToDate,
						status: true
					}
				};

				EmployeeSvc.index(employeeParams)
					.then(function (response) {
						self.employees = response.data.employee_collection;
						if (self.employees.length === 1) {
							self.selectedEmployee = self.employees[0];
						}
					});
			}
		}

		function cancel() {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		}

		function submit() {

			if (self.formValidator.valid()) {
				var params = {
					employee: self.employee,
					moveToDate: self.moveToDate,
					technician: self.selectedEmployee
				};
				TGScheduleSvc.moveMultipleVisits(params).then(function(response) {
					$modalInstance.close(response);
				});
			}
		}

		var self = $scope.TGMoveMultipleCtrl = {
			formvalidatorconfig: {},
			formValidator: {},
			loading: false,
			processing: false,
			moveToDate: null,
			selectedEmployee: null,
			employee: {},
			showMoveToDate: false,
			methods: {
				init: init,
				cancel: cancel,
				submit: submit,
				dateChanged: dateChanged
			}
		};


	});
